function getTLDomain(location) {
    if (location?.hostname?.includes('observability.splunkcloud.com')) {
        return '.observability.splunkcloud.com';
    }
    return '.signalfx.com';
}

/**
 * This service is used to set the realm number and custom domain cookies
 * These cookies are used in the login.signalfx.com page to determine where to direct the user for login.
 */
export default [
    'cookieHelper',
    'SF_REALM_NUMBER',
    'DOMAIN_INFO',
    '$window',
    function (cookieHelper, SF_REALM_NUMBER, DOMAIN_INFO, $window) {
        const KEY = 'SF_LAST_ACTIVE';
        const CUSTOM_DOMAIN_KEY = 'SF_CUSTOM_DOMAIN';
        //the top level domain could also be included as a config.
        const TL_DOMAIN = getTLDomain($window.location);

        function clear() {
            cookieHelper.clear(KEY);
            cookieHelper.clear(CUSTOM_DOMAIN_KEY);
        }

        function set() {
            const expireDate = new Date();
            expireDate.setFullYear(expireDate.getFullYear() + 1);
            const realm = SF_REALM_NUMBER;
            const options = {
                expires: expireDate,
                domain: TL_DOMAIN,
            };
            if (realm) {
                cookieHelper.set(KEY, realm, options);
            }
            if (DOMAIN_INFO?.domain) {
                cookieHelper.set(CUSTOM_DOMAIN_KEY, DOMAIN_INFO.fullDomain, options);
            } else {
                cookieHelper.clear(CUSTOM_DOMAIN_KEY);
            }
        }

        return {
            set,
            clear,
        };
    },
];
